import { proxy } from 'valtio'
import { UserTestsApi } from '../../shared/api/userTestsApi.ts'
import { createStoreContext, useStoreContext } from '../../shared/lib/hooks.ts'
import { UserTest } from '../../shared/api/userTestsApi.ts'

interface State {
  tests: UserTest[]
  loading: boolean
  error: string | null
}

export class UserTestStore {
  state: State

  constructor(private userTestsApi: UserTestsApi) {
    this.state = proxy<State>({
      tests: [],
      loading: false,
      error: null,
    })
  }

  async getTodayTests(courseId?: number | null) {
    try {
      this.state.loading = true
      this.state.error = null
      const tests = await this.userTestsApi.getTodayTests(courseId)
      this.state.tests = tests
    } catch (e) {
      const errorMessage =
        e instanceof Error ? e.message : 'Ошибка загрузки тестов'
      this.state.error = errorMessage
    } finally {
      this.state.loading = false
    }
  }
}

export const UserTestStoreContext = createStoreContext<UserTestStore>()

export function useUserTestStore() {
  return useStoreContext(UserTestStoreContext)
}
